import React from 'react';
import { abs } from 'mathjs';
import { collect } from 'collect.js';
import classNames from 'classnames';
import CaretUpIcon from '../../resources/assets/icons/CaretUpIcon';
import CaretDownIcon from '../../resources/assets/icons/CaretDownIcon';

export const MISSING_VALUE = '–';

export default function MetricItem({
  data,
  formatter = null,
  inline = false,
  isStatic = false,
  isLast = false,
  flipChange = false,
}) {
  const formatValue = (value) => (formatter ? formatter(value) : value);
  const formatChange = (value) => `${abs(value ?? 0).toFixed(2)}%`;

  const renderValue = (field) => {
    // A metric the stats request did not return (a failed or refused request) has no value:
    // show a dash rather than letting the currency formatter print "NaN €".
    if (data?.[field] === undefined || data?.[field] === null) {
      return MISSING_VALUE;
    }

    if (data[field]?.formatted) {
      return data[field].formatted;
    }

    return formatValue(data[field]);
  };

  const renderChange = () => {
    if (!data) {
      return;
    }

    if (Array.isArray(data.change)) {
      return collect(data.change).reduce(
        (result, item) => (result !== '' ? `${result} / ${formatChange(item)}` : formatChange(item)),
        '',
      );
    }

    return formatChange(data.change);
  };

  const showChange = !isStatic && !!data?.change && !Array.isArray(data.change) && data?.change !== 0;

  function ChangeIcon() {
    return data?.change > 0 ? (
      <CaretUpIcon color={flipChange ? '#EB5757' : '#69CE8C'} className="my-auto mr-1" />
    ) : (
      <CaretDownIcon color={flipChange ? '#69CE8C' : '#EB5757'} className="my-auto mr-1" />
    );
  }

  return inline ? (
    <div>
      <div
        className={classNames('flex flex-col', {
          'border-b pb-xs': !isLast,
        })}
      >
        <div className="mb-2xs flex justify-between gap-2">
          <h6 className="mini semibold">{data?.name}</h6>
          {showChange && (
            <div className="flex">
              <ChangeIcon />
              {renderChange()}
            </div>
          )}
        </div>
        <div className="flex gap-2 justify-between">
          <p className="mini medium">{renderValue('value')}</p>
          {!isStatic &&
            !!data?.previous &&
            data?.previous !== 0 &&
            (!Array.isArray(data?.previous) || collect(data.previous).every((item) => !!item)) && (
              <>
                <p className="mini medium">vs.</p>
                <p className="mini medium">{renderValue('previous')}</p>
              </>
            )}
        </div>
      </div>
    </div>
  ) : (
    <>
      <div className="flex gap-2 justify-between items-center">
        <h6 className="mb-0 medium">{renderValue('value')}</h6>
        {!isStatic &&
          !!data?.previous &&
          data?.previous !== 0 &&
          (!Array.isArray(data?.previous) || collect(data.previous).every((item) => !!item)) && (
            <>
              <h6 className="medium mb-0 ">vs.</h6>
              <h6 className="medium mb-0 ">{renderValue('previous')}</h6>
            </>
          )}
      </div>
      <span>
        {showChange && (
          <>
            <ChangeIcon />
            {renderChange()}
          </>
        )}
      </span>
    </>
  );
}
